<template>
   <div>
    <b-modal id="edit-price" ref="edit-price" size="lg" hide-footer :title="$t('message.EDIT_PRICE')"  :no-close-on-backdrop="true" style="margin-top:-101px">
        <div class="row">
            <div class="col-md-6 form-group">
                <label class="label">{{ $t('message.WHERE_TO_DRIVE')}}</label>
                <v-select name="area" :options="areas" v-model="area" v-validate="'required'" :class="{'is-invalid': errors.has('area')}"></v-select>
                <span v-show="errors.has('area')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
            </div>
            <div class="col-md-6 form-group">
                <label class="label">{{ $t('message.NEW_VALUE')}}</label>
                <v-select name="new_value" :options="new_values" v-model="new_value" v-validate="'required'" :class="{'is-invalid': errors.has('new_value')}"></v-select>
                <span v-show="errors.has('new_value')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
            </div>
            <div class="col-md-6 form-group">
                <label class="label">{{ $t('message.OWN_RISK')}}</label>
                <v-select name="own_risk" :options="own_risks" v-model="own_risk" v-validate="'required'" :class="{'is-invalid': errors.has('own_risk')}"></v-select>
                <span v-show="errors.has('own_risk')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
            </div>
            <div class="col-md-6 form-group">
                <label class="label">{{ $t('message.INJURIES')}}</label>
                <v-select name="injury" :options="injuries" v-model="injury" v-validate="'required'" :class="{'is-invalid': errors.has('injury')}"></v-select>
                <span v-show="errors.has('injury')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
            </div>
            <div class="col-md-6 form-group">
                <label class="label">{{ $t('message.PREMIUM')}}</label>
                <input type="number" name="premium" v-model="premium"  class="form-control" v-validate="'required'" :class="{'is-invalid': errors.has('premium')}">
                <span v-show="errors.has('premium')" class="invalid-feedback">{{ $t('message.REQUIRED_FIELD') }}</span>
            </div>
        </div>
       <br />
       <hr>
        <span class="float-right">
        <b-button class="btn btn-info mr-2" v-on:click="update_price">{{ $t("message.UPDATE")}}</b-button>
        <b-button class=" btn btn-danger" @click="$bvModal.hide('edit-price')">{{ $t("message.CLOSE")}}</b-button>
        </span>

    </b-modal>
   </div>
</template>
<script>
import Vue from 'vue'

export default {
    data () {
      return {
          areas: [],
          new_values: [],
          own_risks: [],
          injuries: [],
          premium:'',
          area: '',
          new_value: '',
          own_risk: '',
          injury: '',
          id:'',
      }
    },

    methods:{
        async update_price() {
            const valid = await this.$validator.validateAll()
            if(valid) {
                let form_data = {
                    area_id : this.area.code,
                    new_value_id : this.new_value.code,
                    own_risk_id : this.own_risk.code,
                    injury_id : this.injury.code,
                    premium : this.premium,
                    id:this.id
                }
                let loader = this.$loading.show()

                try {
                    await this.$store.dispatch('admin_price/update_price',form_data)
                    this.$store.dispatch('notifications_alert/success',this.$t('message.MSG_UPDATE_SUCC'))
                    this.$refs['edit-price'].hide()
                    loader.hide()
                } catch (e) {
                    this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
                    loader.hide()
                }
            }
        },

        async get_areas() {
            try {
               let resp = await Vue.prototype.$http.get('/api/area/list')
               resp.data.data.areas.forEach((area) => {
                   this.areas.push({
                       label: area.title,
                       code: area.id
                   })
               })
            } catch (e) {
               this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
            }
        },

        async get_new_values() {
            try {
               let resp = await Vue.prototype.$http.get('/api/new-value/list')
               resp.data.data.new_values.forEach((new_value) => {
                   this.new_values.push({
                       label: new_value.title,
                       code: new_value.id
                   })
               })
            } catch (e) {
               this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
            }
        },
        
        async get_own_risks() {
            try {
               let resp = await Vue.prototype.$http.get('/api/own-risk/list')
               resp.data.data.own_risks.forEach((own_risk) => {
                   this.own_risks.push({
                       label: own_risk.title,
                       code: own_risk.id
                   })
               })
            } catch (e) {
               this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
            }
        },

        async get_injuries() {
            try {
               let resp = await Vue.prototype.$http.get('/api/injury/list')
               resp.data.data.injuries.forEach((injury) => {
                   this.injuries.push({
                       label: injury.title,
                       code: injury.id
                   })
               })
            } catch (e) {
               this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
            }
        },

        async get_data() {
            let loader = this.$loading.show()

            try {
               await this.get_areas()
               await this.get_new_values()
               await this.get_own_risks()
               await this.get_injuries()
               loader.hide()
            } catch (e) {
               this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))
               loader.hide()
            }
        },

        show(price)
        {
            this.reset_form()
            this.get_data()

            this.id = price.id
            this.premium = price.premium
            this.area = {label:price.area_title, code:price.area_id}
            this.new_value = {label:price.new_value_title, code:price.new_value_id}
            this.own_risk = {label:price.own_risk_title, code:price.own_risk_id}
            this.injury = {label:price.injury_id_title, code:price.injury_id}

            this.$refs['edit-price'].show()
        },

        reset_form() {
            this.areas = [],
            this.new_values = [],
            this.own_risks = [],
            this.injuries = [],
            this.premium ='',
            this.area = '',
            this.new_value = '',
            this.own_risk = '',
            this.injury = ''
        }
    }
}
</script>
<style >
.modal.show .modal-dialog{
    margin-top: -101px;
}
</style>